export default "__VITE_ASSET__9a7bd214__"